import { NonterminalKind } from '@nomicfoundation/slang/cst';
import { SlangNode } from './SlangNode.js';
import { StorageLocation } from './StorageLocation.js';
import { TerminalNode } from './TerminalNode.js';

import type * as ast from '@nomicfoundation/slang/ast';
import type { Doc } from 'prettier';
import type { CollectedMetadata, PrintFunction } from '../types.d.ts';

export class UntypedTupleMember extends SlangNode {
  readonly kind = NonterminalKind.UntypedTupleMember;

  storageLocation?: StorageLocation;

  name: TerminalNode;

  constructor(ast: ast.UntypedTupleMember, collected: CollectedMetadata) {
    super(ast, collected);

    if (ast.storageLocation) {
      this.storageLocation = new StorageLocation(
        ast.storageLocation,
        collected
      );
    }
    this.name = new TerminalNode(ast.name, collected);

    this.updateMetadata(this.storageLocation);
  }

  print(print: PrintFunction): Doc {
    const storageLocationDoc = print('storageLocation');
    return [
      storageLocationDoc ? [storageLocationDoc, ' '] : storageLocationDoc,
      print('name')
    ];
  }
}
